import React, { Component } from 'react'
import styled from 'styled-components'

export default class ButtonFiltersMobileV2 extends Component {
  handleClick = (e) => {
    const { onClick, setModalTriggerHeight } = this.props

    onClick && onClick(e)
    if (setModalTriggerHeight) {
      setModalTriggerHeight(this.buttonRef.getBoundingClientRect().top)
    }
  }

  render() {
    const { children, ...restProps } = this.props

    return (
      <Wrapper
        {...restProps}
        innerRef={(ref) => (this.buttonRef = ref)}
        className='iconWrapper'
        onClick={this.handleClick}>
        {children}
      </Wrapper>
    )
  }
}
const Wrapper = styled.div.attrs({ ref: (props) => props.buttonRef })`
  cursor: pointer;
  width: 20px;
  height: 20px;
`



// WEBPACK FOOTER //
// ./src/components/ButtonFiltersMobileVe/index.js